import { NavigationItem } from "component/extra/Navigation";
import { action, observable, toJS } from "mobx";
import { Props } from "wasabi-common/lib";

export interface HeaderItem extends Props<any> {
  name: string;
  value: JSX.Element;
}

export class HeaderStore {
  @observable
  private _active: boolean = false;

  @observable
  private _navigation: NavigationItem[] = [];

  @observable
  private _rightMenus = observable.map();

  @observable
  private _leftMenus = observable.map();

  @observable
  private _centerMenus = observable.map();

  @observable
  private _topSideBarMenus = observable.map();

  @observable
  private _show: boolean = true;

  public get show(): boolean {
    return toJS(this._show);
  }

  @action
  public setShow(value: boolean) {
    this._show = value;
  }

  public get rightMenus(): Map<string, JSX.Element> {
    return toJS(this._rightMenus.toJS());
  }

  public get leftMenus(): Map<string, JSX.Element> {
    return toJS(this._leftMenus.toJS());
  }

  public get centerMenus(): Map<string, JSX.Element> {
    return toJS(this._centerMenus.toJS());
  }

  public get topSideBarMenus(): Map<string, JSX.Element> {
    return toJS(this._topSideBarMenus.toJS());
  }

  @action
  public addLeft(key: string, element: JSX.Element) {
    this._leftMenus.set(key, element);
  }

  @action
  public addCenter(key: string, element: JSX.Element) {
    this._centerMenus.set(key, element);
  }

  @action
  public addRight(key: string, element: JSX.Element) {
    this._rightMenus.set(key, element);
  }

  @action
  public addRightIfNotExist(key: string, element: JSX.Element) {
    if (!this._rightMenus.get(key)) {
      this._rightMenus.set(key, element);
    }
  }

  @action
  public addTopSideBar(key: string, element: JSX.Element) {
    this._topSideBarMenus.set(key, element);
  }

  @action
  public removeLeft(key: string) {
    this._leftMenus.delete(key);
  }

  @action
  public removeCenter(key: string) {
    this._centerMenus.delete(key);
  }

  @action
  public removeRight(key: string) {
    this._rightMenus.delete(key);
  }

  @action
  public removeTopSideBar(key: string) {
    this._topSideBarMenus.delete(key);
  }

  public get active(): boolean {
    return toJS(this._active);
  }

  @action
  public setActive(value: boolean) {
    this._active = value;
  }

  public get navigation(): NavigationItem[] {
    return toJS(this._navigation);
  }

  public setNavigation(value: NavigationItem[]) {
    this._navigation = value;
  }

  @action
  public clearRight(prefix?: string) {
    if (!prefix) {
      this._rightMenus.clear();
      return;
    }
    this.rightMenus.forEach((item, key) => {
      if (key.indexOf(prefix) !== -1) {
        this._rightMenus.delete(key);
      }
    });
  }

  @action
  public reset() {
    this._centerMenus.clear();
    this._leftMenus.clear();
    this._rightMenus.clear();
  }

  @action
  public resetNavigation() {
    this._navigation = [];
  }
}

const headerStore = new HeaderStore();
export default headerStore;
